import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';

@Component({
    selector: 'sx-list-payment-gateways',
    templateUrl: './list.payment.gateways.component.html',
})
export class ListPaymentGatewaysComponent implements OnInit {
    codSistema: string;
    payments: Observable<TemplateListadoItem[]>;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private paymentSrv: PaymentGatewayService,
    ) { }

    link: (TemplateListadoItem) => string[] = (item) => ['./', 'edit', item.id];

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'];
            this.payments = this.paymentSrv.getList(this.codSistema);
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/paymentGateways/list.payment.gateways.component.ts